import { createReducer } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

const initialState = [];

const add = (state, action) => [...state, action.payload];
const pop = (state) => state.slice(0, -1);

export default createReducer(initialState, (builder) => {
  builder
    .addCase(actionTypes.ENQUEUE_NOTIFICATION_TOAST, add)
    .addCase(actionTypes.DEQUEUE_NOTIFICATION_TOAST, pop);
});
